import i18n from '@/i18n/i18n'
import OrderService from '@/services/public/OrderService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  order: null
}

export const mutations = {
  SET_ORDER(state, order) {
    state.order = order.data
  }
}

export const actions = {
  getOrderByHash({ commit, dispatch }, hash) {
    return new Promise((resolve, reject) => {
      OrderService.getOrderByHash(hash)
        .then(response => {
          commit('SET_ORDER', response.data)
          resolve(response.data.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
